import { gql } from 'urql';

export const UpdateCustomerAddress = gql`
  mutation UpdateCustomerAddress(
    $address: AddressInput!
    $addressType: AddressTypeInput!
    $isMailingAddressDifferentThanResidential: Boolean!
  ) {
    updateCustomerAddress(
      input: {
        address: $address
        addressType: $addressType
        isMailingAddressDifferentThanResidential: $isMailingAddressDifferentThanResidential
      }
    ) {
      __typename
      ... on UpdateCustomerAddressSuccess {
        customerInfo {
          email {
            address
          }
        }
      }
      ... on Error {
        code
        title
        message
      }
    }
  }
`;
